<template>
  <el-select v-bind="$attrs"
             class="select-default"
             :placeholder="$t('invoiceStrategy.placeholder')"
             v-on="$listeners">
      <el-option v-for="option in options"
                 class="select-default"
                 :key="option.label"
                 :label="option.label"
                 :value="option.value">
      </el-option>
  </el-select>
</template>
<script>
  import { Select, Option } from 'element-ui'
  export default {
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    computed: {
      options() {
        return [
          {
            label: this.$t('invoiceStrategy.monthly-begin'),
            value: 'monthly-begin'
          },
          {
            label: this.$t('invoiceStrategy.threshold-amount'),
            value: 'threshold-amount'
          },
          {
            label: this.$t('invoiceStrategy.threshold-spend'),
            value: 'threshold-spend'
          },
          {
            label: this.$t('invoiceStrategy.monthly-end'),
            value: 'monthly-end'
          },
        ]
      }
    }
  }
</script>
<style>
</style>
